export const ELEMENT_ROW_NODE_NAME = 'element-row-node';
